import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $isListItemNode } from '@lexical/list';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_LOW,
  INDENT_CONTENT_COMMAND,
  KEY_TAB_COMMAND,
  OUTDENT_CONTENT_COMMAND,
} from 'lexical';
import { useEffect } from 'react';

/**
 * Tab / Shift+Tab indent and outdent — but only inside list items. Everywhere
 * else Tab keeps its default behavior (moving focus to the next control), so the
 * editor is never a keyboard trap. We also scope it to lists deliberately:
 * markdown can represent nested list items but not indented paragraphs, so
 * indenting plain text would be silently lost on save.
 */
export function TabListIndentPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_TAB_COMMAND,
      (event: KeyboardEvent) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;

        const inList = selection.anchor
          .getNode()
          .getParents()
          .some($isListItemNode);
        if (!inList) return false; // let Tab move focus out of the editor

        event.preventDefault();
        editor.dispatchCommand(
          event.shiftKey ? OUTDENT_CONTENT_COMMAND : INDENT_CONTENT_COMMAND,
          undefined,
        );
        return true;
      },
      COMMAND_PRIORITY_LOW,
    );
  }, [editor]);

  return null;
}
